import firebase from '../firebase/config'

export default (uid, vault) => {
    return (dispatch) => {
        dispatch({ type: 'fetch_password_loading' })
        try {
            firebase.database().ref(`users/${uid}/vaults/${vault}`).once('value', function (snapshot) {
                if (snapshot.val()) {
                    let vaults = Object.entries(snapshot.val())
                    dispatch({ type: 'fetch_password_success', payload: vaults })
                    dispatch({ type: 'FOR_SEARCH', payload: vaults })
                } else {
                    dispatch({ type: 'fetch_password_success', payload: [] })
                }
            })
        } catch (error) {
            dispatch({ type: 'fetch_password_error' })
        }
    }
}